import React from 'react';
import { offerConfig } from '../data/siteConfig';
const STATS = [{
  value: '+240',
  label: 'páginas imprimibles'
}, {
  value: '+150',
  label: 'ejercicios en 3 niveles'
}, {
  value: 'Al instante',
  label: 'en tu mail'
}, {
  value: `${offerConfig.guaranteeDays} días`,
  label: 'de garantía'
}];
export const MetricsTestimonialsSection = () => {
  return <section className="bg-familia-darkCard border-y border-familia-darkBorder py-8 md:py-12 px-4 md:px-6" data-id="element-131" data-mp="2m82i7ukwakfl">
      <div className="max-w-6xl mx-auto w-full" data-id="element-132" data-mp="2h8r12kgm9cxh">
        <dl className="grid grid-cols-2 md:grid-cols-4 gap-y-6 md:divide-x md:divide-familia-darkBorder" data-id="element-133" data-mp="2d8firebq7op6">
          {STATS.map(s => <div key={s.label} className="text-center px-2 flex flex-col-reverse" data-id="element-134" data-mp="28anpogzchwje">
              <dt className="text-[15px] sm:text-[17px] text-familia-onDarkMuted leading-snug mt-1" data-id="element-135" data-mp="23cm3voajbj48">
                {s.label}
              </dt>
              <dd className="text-[26px] sm:text-4xl lg:text-5xl font-display font-bold text-familia-accent leading-tight whitespace-nowrap" data-id="element-136" data-mp="1jxyb8af4jla">
                {s.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
};